import {
  CHANGE_MY_CASES_PAGE_LOADING,
  CHANGE_SP_CASES,
  CHANGE_TOTAL,
  CHANGE_OFFSET,
  CHANGE_PER_PAGE,
  CHANGE_FILTER_VISIBLE,
  CHANGE_FILTER_COMPANIES,
  CHANGE_FILTER_LAW_FIRMS,
  CHANGE_FILTER_CREATED_BY,
  CHANGE_FILTER_CLASSIFIERS,
  CHANGE_FILTER_ARCHIVE_REASONS
} from './actions'

export default function(state = {
  loading: {
    exporting: false,
    visible: false
  },
  spCases: [],
  total: 0,
  offset: 0,
  perPage: 15,
  filter: {
    visible: false,
    companies: [],
    lawFirms: [],
    createdBy: [],
    classifiers: [],
    archiveReasons: []
  },
}, action) {
  switch(action.type) {
    case CHANGE_MY_CASES_PAGE_LOADING:
      return { ...state, loading: action.payload }
    case CHANGE_SP_CASES:
      return { ...state, spCases: action.payload }
    case CHANGE_TOTAL:
      return { ...state, total: action.payload }
    case CHANGE_OFFSET:
      return { ...state, offset: action.payload }
    case CHANGE_FILTER_VISIBLE:
      return { ...state, filter: { ...state.filter, visible: action.payload }}
    case CHANGE_FILTER_COMPANIES:
      return { ...state, filter: { ...state.filter, companies: action.payload }}
    case CHANGE_FILTER_LAW_FIRMS:
      return { ...state, filter: { ...state.filter, lawFirms: action.payload }}
    case CHANGE_FILTER_CREATED_BY:
      return { ...state, filter: { ...state.filter, createdBy: action.payload }}
    case CHANGE_FILTER_CLASSIFIERS:
      return { ...state, filter: { ...state.filter, classifiers: action.payload }}
    case CHANGE_FILTER_ARCHIVE_REASONS:
      return { ...state, filter: { ...state.filter, archiveReasons: action.payload }}
    default:
      return state
  }
}
